const defaultSansVoteMajorityId = "498c7090-d1d0-4de6-971a-555ae27aeb3c";
const franceAndDOMCountries = ["FR", "GP", "MQ", "YT", "RE", "GF"];
const trackLetterDeliveryUrl = "https://www.laposte.fr/outils/suivre-vos-envois?code=";

export { defaultSansVoteMajorityId, franceAndDOMCountries, trackLetterDeliveryUrl };
